import { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { AuthContext } from "../context/AuthContext";

export const useResolvedAuth = () => {
  const { inProgress } = useMsal();
  const authContext = useContext(AuthContext);

  const isAuthenticated = authContext?.isAuthenticated ?? false;
  const currentUser = authContext?.currentUser;
  const loading = authContext?.loading ?? false;
  const needsRegistration = authContext?.needsRegistration ?? false;

  const isAuthResolving =
    inProgress !== InteractionStatus.None ||
    loading ||
    (isAuthenticated && !currentUser && !needsRegistration);

  return {
    isAuthenticated,
    currentUser,
    loading,
    needsRegistration,
    isAuthResolving,
  };
};
